export default { // ...existing code... emits: ['hide-sidebar'], // ...existing
code... }
<template>
  <div style="display: flex; align-items: center; gap: 1rem">
    <button class="sidebar-btn" @click="toggleSidebar">
      <img
        v-if="sidebarVisible"
        src="/assets/icons/dock_to_right.svg"
        alt="Sidebar sluiten"
        style="width: 28px; height: 28px"
      />
      <img
        v-else
        src="/assets/icons/dock_to_right.svg"
        alt="Sidebar openen"
        style="width: 28px; height: 28px; opacity: 0.5"
      />
    </button>
    <h1>{{ title }}</h1>
  </div>
</template>

<script>
export default {
  name: "PageHeader",
  emits: ["hide-sidebar"],
  props: {
    title: {
      type: String,
      required: true,
    },
    sidebarVisible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    toggleSidebar() {
      this.$emit("hide-sidebar", !this.sidebarVisible);
    },
  },
};
</script>

<style scoped>
.sidebar-btn {
  background: none;
  border: none;
  padding: 0.25rem 0.5rem;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.18s;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  width: 40px;
}
.sidebar-btn:hover {
  background: var(--surface-light);
}
.sidebar-btn img {
  width: 28px;
  height: 28px;
}
</style>
